// The functions for controlling the ratings
var TECL_SupplierRatingCriteria = {
  
  // Supplier rating's changed
  RatingChanged: function (itemRowId, supplierTenderId, metaDataFieldFieldName, metaDataFieldId) {
    
    var $itemRow = $(itemRowId);

    if ($itemRow) {
      var $valueControl = $itemRow.find("[name=ratingCriteriaValue]");

      if ($valueControl) {
        var ratingValue = $valueControl.val();

        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/SupplierRatingChange",
          type: "POST",
          data: {
            supplierTenderId: supplierTenderId,
            metaDataFieldFieldName: metaDataFieldFieldName,
            ratingValue: ratingValue,
            metaDataFieldId: metaDataFieldId
          },
          error: function (exc) {
          },
          success: function (saved) {
            if (saved) {
              var $valueDisplay = $itemRow.find(".ratingCriteriaValueDisplay");

              if ($valueDisplay) {
                $valueDisplay.html(ratingValue + "/5");
              }
            }
          }
        });
      }
    }
  }

}